import { MessagesTable, Layout } from "components"

export const MessageTable = () => {
 return (
  <Layout>
   <MessagesTable />
  </Layout>
 )
}


